<template>
  <div class="box-outer">
    <label v-if="label" :for="`id_${name}`" class="label">{{ label }}</label>
    <input
      v-if="name"
      :id="`id_${name}`"
      :type="type"
      :name="name"
      :min="min"
      :placeholder="placeholder"
      :value="value"
      :maxlength="maxlength"
      :class="{ 'input-error': errors.length }"
      class="input"
      @input="handleInput"
      @blur="handleInput"
    />
    <error-component :errors="errors" />
  </div>
</template>

<script>
import ErrorComponent from '@/components/Error'
import { capitalize } from '@/utils/utils'

export default {
  components: {
    ErrorComponent
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    maxlength: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    min: {
      type: String,
      default: ''
    },
    errors: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    capitalize: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleInput(evt) {
      let value = evt.target.value
      if (this.capitalize && value.length === 1) {
        value = capitalize(value)
      }
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.box-outer {
  margin: 28px 0 0;
  .field &,
  .fields-wrap & {
    margin: 0;
  }
}

.label {
  @include label;
}

.input {
  @include input;

  &[type='time'] {
    padding: 12px 18px;
  }
}

.input-error {
  border: 2px solid $error;
}
</style>
